var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { GalaxyApi } from "@/api";
import { useUserStore } from "@/stores/userStore";
import { withPrefix } from "@/utils/redirect";
import { rethrowSimple } from "@/utils/simple-error";
export function loadWorkflows({ sortBy = "update_time", sortDesc = true, limit = 20, offset = 0, filterText = "", showPublished = false, skipStepCounts = true, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const { response, data, error } = yield GalaxyApi().GET("/api/workflows", {
            params: {
                query: {
                    sort_by: sortBy,
                    sort_desc: sortDesc,
                    limit,
                    offset,
                    search: filterText,
                    show_published: showPublished,
                    skip_step_counts: skipStepCounts,
                },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        const totalMatches = parseInt(response.headers.get("Total_matches") || "0", 10) || 0;
        return { data, totalMatches };
    });
}
export function updateWorkflow(id, changes) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.put(withPrefix(`/api/workflows/${id}`), changes);
        return data;
    });
}
export function copyWorkflow(id, currentOwner, version) {
    return __awaiter(this, void 0, void 0, function* () {
        let path = `/api/workflows/${id}/download`;
        if (version) {
            path += `?version=${version}`;
        }
        const { data: workflowData } = yield axios.get(withPrefix(path));
        workflowData.name = `Copy of ${workflowData.name}`;
        const userStore = useUserStore();
        if (!userStore.matchesCurrentUsername(currentOwner)) {
            workflowData.name += ` shared by user ${currentOwner}`;
        }
        const { data } = yield axios.post(withPrefix("/api/workflows"), { workflow: workflowData });
        return data;
    });
}
export function deleteWorkflow(id) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.delete(withPrefix(`/api/workflows/${id}`));
        return data;
    });
}
export function undeleteWorkflow(id) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.post(withPrefix(`/api/workflows/${id}/undelete`));
        return data;
    });
}
export function createWorkflow(workflowName, workflowAnnotation) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.put(withPrefix("/workflow/create"), {
            workflow_name: workflowName,
            workflow_annotation: workflowAnnotation,
        });
        return data;
    });
}
export function getWorkflowFull(workflowId, version) {
    return __awaiter(this, void 0, void 0, function* () {
        let url = `/workflow/load_workflow?_=true&id=${workflowId}`;
        if (version !== undefined) {
            url += `&version=${version}`;
        }
        const { data } = yield axios.get(withPrefix(url));
        return data;
    });
}
export function getWorkflowInfo(workflowId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get(withPrefix(`/api/workflows/${workflowId}`));
        return data;
    });
}
